import { gql } from "@apollo/client";
import { captureException } from "@sentry/browser";
import { apollo, AppDispatch, AppThunk } from "./index";
import { INFOBAR_SET } from "./types";

export const getInfobar = (): AppThunk => async (dispatch: AppDispatch) => {
  try {
    const req: any = await apollo().query({
      query: gql`
        query {
          canteenLocationsForCustomer {
            message
            messageType
            isMessageActive
          }
        }
      `,
    });

    const canteenLocationsForCustomer = req.data.canteenLocationsForCustomer;

    for (const canteenLocationForCustomer of canteenLocationsForCustomer) {
      if (canteenLocationForCustomer.isMessageActive === true) {
        dispatch({
          type: INFOBAR_SET,
          message: canteenLocationForCustomer.message,
          messageType: canteenLocationForCustomer.messageType,
          isMessageActive: canteenLocationForCustomer.isMessageActive,
        });
      }
    }
  } catch (err) {
    captureException(err);
  }
};
